import styled from 'styled-components';

type ListItemPreviewProps = {
  color?: string;
  image?: string;
  error?: boolean;
};

const StyledListItemPreview = styled.div<ListItemPreviewProps>`
  margin-left: 10px;
  width: 50px;
  height: 50px;
  border: 1px solid rgba(148, 147, 166, 0.5);
  border-radius: 50%;
  background-color: ${(props) => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledListItemPreviewImg = styled.img`
  margin-left: 10px;
  width: 50px;
  height: 50px;
  border: 1px solid rgba(148, 147, 166, 0.5);
  border-radius: 50%;
`;

const StyledListItemNumber = styled.div`
  font-size: 12px;
  padding: 1px 1px 0 0;
  background-color: #cdcdcd;
  color: white;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  z-index: 1;
  position: absolute;
  left: 10px;
`;

export {
  StyledListItemPreview,
  StyledListItemPreviewImg,
  StyledListItemNumber
};
